import React from "react";
import { useAuth } from "@/context/AuthContext";
import StudentDashboard from "@/pages/StudentDashboard";
import TeacherDashboard from "@/pages/TeacherDashboard";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import SchoolDashboard from "@/pages/SchoolDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (user.role === "student") return <StudentDashboard />;
  if (user.role === "teacher") return <TeacherDashboard />;
  if (user.role === "parent") return <ParentDashboard />;
  if (user.role === "school") return <SchoolDashboard />;
  return <AdminDashboard />;
}
